/**
 * DetailsElement Module
 * helper class
 * for <details> elements
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.detailElements = document.querySelectorAll('.useful-links__details');
    this.mql = window.matchMedia('(min-width: 1024px)');

    this.detailsElementHandling();

    try {
      //  Chrome & Firefox
      this.mql.addEventListener('change', () => this.detailsElementHandling());
    } catch (e1) {
      try {
        //  Safari
        this.mql.addListener(() => this.detailsElementHandling());
      } catch (e2) {
        console.error(e2);
      }
    }
  }

  /**
   * @function detailsElementHandling
   * @desc adds attribute 'open' to <details> elements
   *       when viewport is >= large (1024px)
   */
  detailsElementHandling() {
    if (this.mql.matches) {
      this.detailElements.forEach((element) => {
        element.setAttribute('open', '');
      });
    }
  }
}
